import _ from 'lodash';
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import Loading from '../../../../shared/loading';
import CompaniesContext from './context';
import { HeaderMixin } from '../../shared/styles';
import Upload from './brand-components/upload';
import Color from './brand-components/color';
import Preview from './brand-components/preview';
import useSaveBrand from './brand-components/save-brand-hook';

const SModal = styled(Modal)`
  & > article.horizontal {
    min-width: 700px;
    min-height: 550px;
  }
`;

const Title = styled.h5`
  ${HeaderMixin};
  font-size: 14px;
  text-align: center;
`;

const Body = styled(Modal.Body)`
  display: flex;
  margin: 20px 25px 40px 25px;
  flex-wrap: wrap;
  padding: 0 !important;
  height: 100%;
`;

const BtnGroup = styled.div`
  margin: 25px;
  display: flex;
  justify-content: flex-end;
`;

export default function BrandCompanyModal() {
  const {
    state: { showBrandModal, currentEditingCompany: company },
    dispatch,
  } = React.useContext(CompaniesContext);
  const [color, setColor] = React.useState(company.logoColor);
  const [logo, setLogo] = React.useState(company.logoPictureUrl);
  const [{ loading, complete, company: newCompany }, save] = useSaveBrand();

  const loadingRef = React.useRef();

  const dismiss = React.useCallback(e => {
    e && e.preventDefault();
    dispatch({ type: 'dismissModal' });
  }, [dispatch]);

  const saveHandler = e => {
    e && e.preventDefault();
    save(company, logo, color);
  };

  React.useEffect(() => {
    complete && dismiss();
  }, [complete, dismiss]);

  React.useEffect(() => {
    const c = _.pickBy(newCompany, (v, k) => k !== 'dirty');
    newCompany.dirty && dispatch({ type: 'companyUpdated', payload: c });
  }, [newCompany, dispatch]);

  React.useEffect(() => {
    setLogo(company.logoPictureUrl);
    setColor(company.logoColor || '');
  }, [company]);

  React.useEffect(() => {
    loadingRef.current && loadingRef.current.toggle(loading);
  }, [loading]);

  const safeLogo = _.get(logo, 'content', logo);

  return (
    <SModal
      centered="true"
      dialogAs="article"
      dialogClassName="horizontal"
      show={showBrandModal}
      onHide={dismiss}
    >
      <Modal.Header>
        <Title>Setup Company Branding</Title>
      </Modal.Header>
      <Body>
        <Upload logo={safeLogo} onChange={setLogo} />
        <Color color={color} onChange={setColor} />
        <Preview color={color} logo={safeLogo} />
      </Body>
      <Modal.Footer as="footer">
        <BtnGroup>
          <Loading variant="sip" ref={loadingRef} />
          <button type="button" className="btn btn-secondary" onClick={dismiss}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={saveHandler}>
            Save
          </button>
        </BtnGroup>
      </Modal.Footer>
    </SModal>
  );
}
